module.exports = __webpack_public_path__ + "img/question.d087d1ea.svg";